// src/utils/axios.js
import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'


// 权限中心地址
export const permissionBaseURL = 'http://172.16.1.15:20214'

// 权限中心专用 axios 实例
export const axios_perm = axios.create({
  baseURL: permissionBaseURL,
  timeout: 300000
})

// 权限中心请求统一加 token
axios_perm.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
  }
  return config
})

// ========================
// 配置服务器地址
// ========================
// const businessBaseURL = 'http://172.16.1.15:20210'
const businessBaseURL = 'http://cloud-print.wanglv.top'
const authBaseURL = 'http://auth.wanglv.top'
// const authBaseURL = 'http://172.16.1.15:20145'

// ========================
// 创建axios实例（默认业务服务器）
// ========================
const instance = axios.create({
  baseURL: businessBaseURL,
  timeout: 300000,
})

// ========================
// 刷新token相关
// ========================
let isRefreshing = false
let refreshQueue = []

function processQueue(error, token = null) {
  refreshQueue.forEach(p => {
    if (error) {
      p.reject(error)
    } else {
      p.resolve(token)
    }
  })
  refreshQueue = []
}

// ========================
// 请求拦截器
// ========================
instance.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
  }
  return config
})

// ========================
// 响应拦截器
// ========================
instance.interceptors.response.use(
  res => res,
  async error => {
    const { config, response } = error

    if (!response) {
      return Promise.reject(error)
    }

    // 只处理业务服务器返回的401
    if (response.status === 401 && !config.__isRetryRequest && config.baseURL === businessBaseURL) {
      if (!isRefreshing) {
        isRefreshing = true
        try {
          const refresh_token = localStorage.getItem('refresh_token')
          const resp = await axios.post(`${authBaseURL}/api/v1/auth/token/refresh`, { refresh_token })

          if (resp.data.code === 1) {
            const newToken = resp.data.data.access_token
            localStorage.setItem('access_token', newToken)
            processQueue(null, newToken)
            isRefreshing = false

            config.headers['Authorization'] = 'Bearer ' + newToken
            config.__isRetryRequest = true
            return instance(config)
          } else {
            throw new Error('刷新token失败')
          }
        } catch (err) {
          processQueue(err, null)
          isRefreshing = false
          localStorage.removeItem('access_token')
          localStorage.removeItem('refresh_token')
          router.push('/')
          Message.error('登录已过期，请重新登录')
          return Promise.reject(err)
        }
      } else {
        return new Promise((resolve, reject) => {
          refreshQueue.push({
            resolve: token => {
              config.headers['Authorization'] = 'Bearer ' + token
              config.__isRetryRequest = true
              resolve(instance(config))
            },
            reject: err => {
              reject(err)
            },
          })
        })
      }
    }

    return Promise.reject(error)
  }
)

// ========================
// 封装常用请求方法
// ========================
const http = {
  get(url, params = {}, config = {}) {
    return instance.get(url, {
      params,
      ...config
    })
  },

  post(url, data = {}, config = {}) {
    return instance.post(url, data, {
      ...config
    })
  },

  put(url, data = {}, config = {}) {
    return instance.put(url, data, {
      ...config
    })
  },

  delete(url, params = {}, config = {}) {
    return instance.delete(url, {
      params,
      ...config
    })
  },

  patch(url, data = {}, config = {}) {
    return instance.patch(url, data, {
      ...config
    })
  }
}

// ========================
// 导出
// ========================
export { http ,authBaseURL, businessBaseURL}
export default instance



// WEBPACK FOOTER //
// ./src/utils/axios.js